import React, { useContext, useEffect, useRef, useState } from 'react'
import { useMutation, useQuery } from '@apollo/client'
import { Link } from 'react-router-dom'
import moment from 'moment'
import Swal from 'sweetalert2'
import ContentHeader from '../../../Layout/ContentHeader'
import LayoutTable from '../../../Global/LayoutTable'
import { AuthContext } from '../../../../Auth/AuthContext'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import Select from 'react-select'
//import Box from '../../../Global/Box'
import { useLoading } from '../../../../LoadingOverlay/LoadingOverlayContext'
import {
  fnArraySelectStatus,
  findArrayStatus,
  fnObjNameStatus,
  fnStatusArrayCanSeeRole_internalManager,
  fnStatusArrayCanSeeRole_globalManager,
  fnObjNameStatusReport,
} from '../../../../const/constStatuses'
import { objNameRoles } from '../../../../const/constRoles'
import ReportsFilters from './components/ReportsFilters'
import {
  CHANGE_REPORT_STATUS,
  EXPORT_REPORTS,
  GET_ALL_REPORTS,
  UPDATE_PRIORITY_REPORT,
} from '../../../../graphql/Catalog/Reports/reports'
import { GET_ALL_JURISDICTIONS_AND_SUBS } from '../../../../graphql/Catalog/Jurisdictions/jurisdictions'
import { GET_INTERNAL_NOTES } from '../../../../graphql/Catalog/InternalNotes/internalNotes'
import { GET_ALL_STATUS_ROLES_BY_TYPE_STATUS_OF_USER_CONTEXT } from '../../../../graphql/Catalog/Status/statusRoleVisibility'
import { GET_ALL_COLONIES } from '../../../../graphql/Global/sepomex'
import ModalContent from '../../../Global/ModalContent'
import ModalStatus from './components/ModalChangeStatus/ModalStatus'
import ProgressBarStatusReport from '../../../Global/ProgressBarStatusReport'
import ModalReportsDuplicated from './components/ModalReportsDuplicated/ModalReportsDuplicated'
import ReportsRelated from './components/ReportsRelated'

import 'moment/locale/es'
import ReportsChanel from './components/ReportsChanel'
import { GET_ALL_STATUS } from '../../../../graphql/Catalog/Status/status'
import ReportsSubCategory from './components/ReportsSubCategory'
import { CSVLink } from 'react-csv'
import withReactContent from 'sweetalert2-react-content'
import { GET_ALL_GROUPS_CATEGORIES_SUBS } from '../../../../graphql/Catalog/Groups/groupsCategoriesSubs'
import ModalReportPdf from './components/ModalReportPdf/ModalReportPdf'
import ModalEditReports from './components/ModalEditReports/ModalEditReports'
import ModalReportUserAppInfo from './components/ModalReportUserAppInfo/ModalReportUserAppInfo'
import { useLocation } from 'react-router'
import PriorityBox from '../WaterTruckRequest/components/PriorityBox'
import { EXPORTATION_ACTIVITY_REPORTS_COUNTERS } from '../../../../graphql/Document/DashboardActivityByRol/dashboardActivityByRol'
const objNameStatus = fnObjNameStatus()
const objNameStatusReport = fnObjNameStatusReport()
const idModalFilters = 'modalFilters'
// const filterRangeTypesDateOptions = [
//   {
//     value: 'start_date',
//     label: 'Fecha inicio',
//   },
//   {
//     value: 'due_date',
//     label: 'Fecha de vencimiento',
//   },
//   {
//     value: 'completed_at',
//     label: 'Fecha de finalización',
//   },
// ]

export const Reports = () => {
  const MySwal = withReactContent(Swal)
  const priorityOptions = [
    { value: 'normal', label: 'Normal' },
    { value: 'urgente', label: 'Urgente' },
  ]
  moment.locale('es') //Change dates languages to spanish
  const { user } = useContext(AuthContext)
  const roleEnlace = objNameRoles.enlace_de_gobierno
  const isRoleEnlace = user?.role === roleEnlace
  const location = useLocation()
  const { showLoading, hideLoading } = useLoading()
  const webChannels = ['web', 'web_gestor', 'web_anonymous']
  const allowedRoles = [
    objNameRoles.master,
    objNameRoles.admin,
    objNameRoles.atencion_ciudadana,
  ]

  const isGestorInterno =
    user.role === objNameRoles.gestor_interno ? true : false
  const isAllowed = allowedRoles.includes(user.role)

  //REFS
  const refModalFilters = useRef()
  const refModalStatus = useRef(null)

  //STATES:
  const [pagePagination, setPagePagination] = useState({
    searchQuery: null,
    limit: 10,
    offset: 0,
    onlySearchFolio: true,
    filtersReports: {
      status_id: null,
      jurisdiction_id: null,
      sub_jurisdiction_id: null,
      zone_id: null,
      colony_id: null,
      group_category_sub_id: null,
      nameColumnDateType: 'start_date',
      dateFrom: null,
      dateTo: null,
      own_reports: null,
      priority: null, // Added priority filter
    },
  })

  const [total, setTotal] = useState(0)
  const [dataToTable, setDataToTable] = useState([])
  const [dataToTableExport, setDataToTableExport] = useState([])

  const [arraySelectStatus, setArraySelectStatus] = useState([])
  const [varsJurisdiction, setVarsJurisdiction] = useState({
    isJurisdiccionVisible: false,
    jurisdiccionSelected: '',
    jurisdictions: [],
    isSubJurisdiccionVisible: false,
    subJurisdiccionSelected: '',
    subJurisdictions: [],
  })
  const [typeDateSelected, setTypeDateSelected] = useState('')
  const [isFiltered, setIsFiltered] = useState(false)
  const [statusOfRole, setStatusOfRole] = useState([])
  const [buttonsPermissions, setButtonsPermissions] = useState({
    edit: false,
  })

  //To fill filter options
  const [filterOptions, setFilterOptions] = useState({
    status: [],
    jurisdictions: [],
    zones: [],
    colonies: [],
    subcategories: [],
    modalOptionsStatus: [],
    modalOptionsSubcategories: [],
    modalOptionsZones: [],
    priorityOptions: priorityOptions,
  })
  //STATE MODAL
  const [closeModal, setCloseModal] = useState(false)
  const [modal, setModal] = useState({
    modalId: false,
    size: 'extra',
    title: '',
    content: null,
  })

  //MUTATIONS
  const [changeStatus] = useMutation(CHANGE_REPORT_STATUS, {
    refetchQueries: [
      {
        query: GET_INTERNAL_NOTES,
        fetchPolicy: 'no-cache',
      },
    ],
  })

  const [ExportReports] = useMutation(EXPORT_REPORTS)

  const [exportCounterReports] = useMutation(
    EXPORTATION_ACTIVITY_REPORTS_COUNTERS
  )

  //QUERIES:
  const { loading, error, data, refetch } = useQuery(GET_ALL_REPORTS, {
    variables: {
      ...pagePagination,
      // ...(user?.role == 7 && { statusIds: [13, 7] }), //13 = Comunicar ejecución, 7 = Solucionado, Rol 7 = Atención Ciudadana.
    },
    fetchPolicy: 'no-cache',
  })

  const {
    data: dataStatus,
    loading: loadingStatus,
    error: errorStatus,
  } = useQuery(GET_ALL_STATUS, {
    variables: {
      type: 'Reports',
      getOwnStatus: true,
      //NOTE: This role now can see all status
      // ...(user?.role === objNameRoles.atencion_ciudadana && { ids: [13, 7, 14, 15] }), //13 = Comunicar ejecución, 7 = Solucionado, 14 = Comunicar cancelación, 15 = Cancelado Rol 7 = Atención Ciudadana.
    },
  })

  const {
    data: dataJurisdictionsAndSubs,
    loading: loadingJurisdictionsAndSubs,
    error: errorJurisdictionsAndSubs,
  } = useQuery(
    GET_ALL_JURISDICTIONS_AND_SUBS,
    {
      variables: {
        jurisdiction_id:
          isGestorInterno && user.jurisdiction_id ? user.jurisdiction_id : null,
      },
    },
    { fetchPolicy: 'no-cache' }
  )

  const {
    data: dataJuri,
    loading: loadingJuri,
    error: errorJuri,
  } = useQuery(GET_ALL_JURISDICTIONS_AND_SUBS)

  const {
    data: dataColonies,
    loading: loadingColonies,
    error: errorColonies,
  } = useQuery(GET_ALL_COLONIES, {
    fetchPolicy: 'cache-first',
  })

  const {
    data: dataGroupsCategoriesSubs,
    loading: loadingGroupsCategoriesSubs,
    error: errorGroupsCategoriesSubs,
  } = useQuery(GET_ALL_GROUPS_CATEGORIES_SUBS, {
    variables: {
      filterContext: true,
    },
  })

  const {
    data: dataStatusRole,
    loading: loadingStatusRole,
    error: errorStatusRole,
  } = useQuery(GET_ALL_STATUS_ROLES_BY_TYPE_STATUS_OF_USER_CONTEXT, {
    variables: {
      type_status: 'Reports',
    },
  })

  //FUNCTIONS

  const handleExtraOptions = async ({
    reportData,
    type,
    current_status,
    next_status,
  }) => {
    if (type === 'changeEstatusTo_rechazar') {
      return handleCancelStatus({
        reportData,
        current_status,
        next_status,
      })
    }
  }

  const handleCancelStatus = async ({
    reportData,
    current_status,
    next_status,
  }) => {
    try {
      const results = await toastSweetAlert({
        mode: 'modalConfirmContent',
        title: 'Rechazar reporte',
        content: contentInvoice({
          text: `¿Estas seguro de pasar del estado ${current_status.labelMain} a ${next_status.labelMain}?`,
          next_status,
        }),
        validator: null,
      })
      if (results.isConfirmed) {
        const input = {
          reportId: reportData.id,
          statusIdNext: next_status.id,
          planning_date: null,
        }

        toastSweetAlert({
          mode: 'loading',
          message: 'Procesando, espere un momento.',
        })

        const res = await changeStatus({
          variables: { input },
        })

        await refetch()
        if (res) {
          return toastSweetAlert({
            mode: 'okToast',
            message: `El reporte paso al nuevo estado ${next_status.labelMain} con exito`,
          })
        }
      }
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }

  const handleNextStatus = async ({
    reportData,
    current_status,
    next_status,
  }) => {
    try {
      const results = await toastSweetAlert({
        mode: 'modalConfirmContent',
        title: '',
        content: contentInvoice({
          text: `¿Pasar del estado ${current_status.labelMain} a ${next_status.labelMain}?`,
          next_status,
        }),
        validator: () =>
          next_status.id === objNameStatus.planificar
            ? validatorPlanningDate()
            : null,
      })
      if (results.isConfirmed) {
        let planning_date = null
        if (next_status.id === objNameStatus.planificar) {
          planning_date = document.getElementById(`planning_date`).value
        }

        const input = {
          reportId: reportData.id,
          statusIdNext: next_status.id,
          planning_date,
        }

        showLoading()

        try {
          const res = await changeStatus({
            variables: { input },
          })

          await refetch()

          if (res) {
            return toastSweetAlert({
              mode: 'okToast',
              message: `El reporte paso al nuevo estado ${next_status.labelMain} con exito`,
            })
          }
        } catch (error) {
          return toastSweetAlert({
            mode: 'error',
            message: error.message,
          })
        } finally {
          hideLoading()
        }
      }
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }

  const contentInvoice = ({ text, next_status }) => (
    <div className="message-container mt-3">
      <div>
        <h4 className="p-2">{text}</h4>

        {next_status.id === objNameStatus.planificar && (
          <div className="mt-4">
            <label className="form-label">Fecha de planificacion</label>
            <input
              id={'planning_date'}
              className="form-control rounded-2"
              type="date"
            />
          </div>
        )}
      </div>
    </div>
  )

  const validatorPlanningDate = () => {
    const planning_date = document.getElementById(`planning_date`).value
    if (!planning_date) {
      return Swal.showValidationMessage(
        `Es necesario definir la fecha de planeacion para continuar`
      )
    }
    return true
  }

  const filterOnChange = (e, field) => {
    if (field === 'jurisdiction_id') {
      if (e) {
        setPagePagination((old) => ({
          ...old,
          filtersReports: {
            ...old.filtersReports,
            jurisdiction_id: parseInt(e.value),
            sub_jurisdiction_id: null,
          },
        }))
      } else {
        setPagePagination((old) => ({
          ...old,
          filtersReports: {
            ...old.filtersReports,
            jurisdiction_id: null,
            sub_jurisdiction_id: null,
          },
        }))
      }

      return setVarsJurisdiction((old) => ({
        ...old,
        jurisdiccionSelected: e?.value ? e.value : null,
        subJurisdiccionSelected: null,
        subJurisdictions: e?.subs.length > 0 ? e.subs : [],
      }))
    }

    if (e) {
      setPagePagination((old) => ({
        ...old,
        filtersReports: {
          ...old.filtersReports,
          [field]: parseInt(e.value),
        },
      }))
    } else {
      setPagePagination((old) => ({
        ...old,
        filtersReports: {
          ...old.filtersReports,
          [field]: null,
        },
      }))
    }
  }

  const foundStatusCurrentInStatusRole = (status_id) => {
    return statusOfRole.find((item) => item.status_id === status_id)
  }

  //EFFECTS:

  useEffect(() => {
    if (isRoleEnlace) {
      const existsSpecialOption = priorityOptions.some(
        (option) => option.value === 'especial'
      )
      if (!existsSpecialOption) {
        priorityOptions.push({
          value: 'especial',
          label: 'Especial',
        })
      }
    }
  }, [isRoleEnlace])

  useEffect(() => {
    const permissions = user?.userPermissions
    const findPermission = permissions.find(
      (item) => item?.module_info?.relative_link === location.pathname
    )
    setButtonsPermissions({
      edit: findPermission?.access_edit || false,
    })
  }, [location.pathname, user])

  //Fill status of role
  useEffect(() => {
    if (!loadingStatusRole && !errorStatusRole) {
      if (dataStatusRole) {
        setStatusOfRole(
          dataStatusRole.getAllStatusRoleByTypeStatusOfUserContext
        )
      }
    }
  }, [dataStatusRole, loadingStatusRole, errorStatusRole])

  const handleIsReportCompletedOrRejected = (item) => {
    const statusCompletd = objNameStatus.completado
    const statusRejected = objNameStatus.rechazar

    if (
      item.status_id === statusCompletd ||
      item.status_id === statusRejected
    ) {
      return true
    }

    return false
  }

  useEffect(() => {
    if (!loading) {
      if (error)
        return toastSweetAlert({
          mode: 'error',
          message: error.message,
        })
      let list = []
      data.getAllReports.rows.map((item) => {
        const isCompletedOrRejectedReport =
          handleIsReportCompletedOrRejected(item)

        const found_current_status = findArrayStatus(item.status_id)

        const colorStatus = found_current_status?.classColorTxt ?? ' text-green'

        let varsJuri = {
          // juri: item?.JurisdictionOfReport?.name ?? 'N/A',
          Zona: item?.JurisdictionsSubOfReport?.name ?? 'N/A',
        }
        if (isGestorInterno) {
          varsJuri = {
            Zona: item?.JurisdictionsSubOfReport?.name ?? 'N/A',
          }
        }

        let { currentReport, reportsRelated } =
          item?.currentReportAndReportsRelated

        const newCurrentReport =
          reportsRelated.find((report) => report.isOriginal) || currentReport
        const filteredReportsRelated = reportsRelated.filter(
          (report) => report.isDuplicated
        )
        if (currentReport.isDuplicated) {
          filteredReportsRelated.push(currentReport)
        }
        reportsRelated = filteredReportsRelated

        let ciudadano = 'N/A'
        if (item.channel_capture === 'tlajochat') {
          const from = item?.UserTlajoChatOfReport?.from ? (
            <span style={{ fontSize: 10 }}>
              ({item?.UserTlajoChatOfReport?.from})
            </span>
          ) : (
            ''
          )
          ciudadano = item?.UserTlajoChatOfReport?.name ? (
            <>
              {item?.UserTlajoChatOfReport?.name} {from}
            </>
          ) : (
            'N/A'
          )
        }

        if (item.channel_capture === 'web') {
          ciudadano = item?.ReportCitizenOfUsers?.name || 'N/A'
        }

        if (item.channel_capture === 'web_gestor') {
          ciudadano = item?.ReportToUsers?.name || 'N/A'
        }

        if (item.channel_capture === 'web_anonymous') {
          ciudadano = item?.ReportToUsers?.name || 'N/A'
        }

        if (item.channel_capture === 'app') {
          const suspended = item?.ReportToUsers?.suspended
          ciudadano = (
            <span onClick={() => handleShowInfoUserApp(item.user_id)}>
              {!suspended ? (
                <span title="Información de usuario de app">
                  <i className="fas fa-mobile-alt"></i>
                  &nbsp;{(ciudadano = item?.ReportToUsers?.name)}
                </span>
              ) : (
                <span
                  className="text-bold text-danger"
                  title="Usuario baneado - Información de usuario de app"
                >
                  <i className="fas fa-mobile-alt"></i>
                  &nbsp;{(ciudadano = item?.ReportToUsers?.name)}
                </span>
              )}
            </span>
          )
        }

        return list.push({
          id: item.id,
          Folio: contextMenuFolio(item, isCompletedOrRejectedReport),
          'Tipo/Canal': (
            <>
              <ReportsChanel
                category_name={item?.ReportToGroupCategory?.name}
                img={item?.ReportToGroupCategory?.icon}
                channel_capture={item?.channel_capture}
                sub_category_name={item?.ReportToGroupCategorySub?.name}
                img_sub_category={item?.ReportToGroupCategorySub?.icon}
              />
            </>
          ),
          prioridad: (
            <PriorityBox
              id={item?.id}
              priority={item?.priority}
              updatePriority={item?.priority !== 'especial'}
              mutationUpdate={UPDATE_PRIORITY_REPORT}
              refetchMain={refetch}
              normalStyle={{
                backgroundColor: '#DBE6FF',
                color: '#374151',
                border: '0px',
                padding: '8px 2px',
                borderRadius: '4px',
                width: '100%',
                marginRight: '100px',
              }}
              urgentStyle={{
                backgroundColor: '#DA1E28',
                color: '#FFFFFF',
                border: '0px',
                padding: '8px 2px',
                borderRadius: '4px',
                width: '100%',
                marginRight: '100px',
              }}
              specialStyle={{
                backgroundColor: '#FFD700',
                color: '#000000',
                border: '0px',
                padding: '8px 2px',
                borderRadius: '4px',
                width: '100%',
                marginRight: '100px',
              }}
              showImage={false}
            />
          ),
          Relación: (
            <ReportsRelated
              currentReport={newCurrentReport}
              reportsRelated={reportsRelated}
            />
          ),
          //
          // Folio: (
          //   <Link
          //     style={{
          //       fontWeight: 'bold',
          //       color: '#0d6efd',
          //       textDecoration: 'underline',
          //       cursor: 'pointer',
          //     }}
          //     title="Ver detalles del reporte"
          //     to={`reports/details/${item?.id}/show`}
          //   >
          //     {item?.folio}
          //   </Link>
          // ),
          'Fecha inicio': !item.start_date
            ? 'N/A'
            : moment(item.start_date).format(
                'dddd D [de] MMMM [de] YYYY HH:mm [hrs]'
              ),
          Colonia:
            (item?.colony_id && item?.colony_id > 0
              ? item?.ColonyOfReport?.name
              : 'N/A') || 'N/A',
          estatus: (
            <ProgressBarStatusReport statusReport={item?.StatusOfReport} />
          ),
          ...varsJuri,
          //TODO: SE COMENTA, SE DEBE DESCOMENTAR EN EL MOMENTO INDICADO
          //Colonia: item?.ColonyOfReport?.name || 'N/A',
          ciudadano,
          start_date_only__omit: !item.start_date
            ? 'N/A'
            : moment(item.start_date).format('DD/MM/YYYY'),
          // Subcategoría: (
          //   <ReportsSubCategory
          //     sub_category_name={item?.ReportToGroupCategorySub?.name}
          //     img={item?.ReportToGroupCategorySub?.icon}
          //   />
          // ),
          accions_custom: (
            <div className="my-3 d-flex flex-column acciones">
              <div className="d-flex" style={{ gap: '5px' }}>
                <Link
                  className="btn btn-migrates btn-migrates-cover btn-sm mb-1"
                  to={`reports/details/${item.id}/show`}
                  title="Ver detalles"
                >
                  <i className="fas fa-eye mr-1" />
                </Link>

                {buttonsPermissions.edit &&
                  !isCompletedOrRejectedReport &&
                  ![
                    objNameStatusReport.Solucionado,
                    objNameStatusReport.Cancelado,
                  ].includes(item.status_id) && (
                    // item.priority !== 'especial' &&
                    <button
                      className="btn btn-migrates btn-migrates-cover btn-sm mb-1"
                      onClick={(e) => handleEditReport(item.id, item?.folio)}
                      title="Editar reporte"
                    >
                      <i className="fas fa-edit mr-1" />
                    </button>
                  )}

                {foundStatusCurrentInStatusRole(item.status_id) && (
                  <button
                    className="btn btn-migrates btn-migrates-cover btn-sm mb-1"
                    onClick={(e) =>
                      handleOpenModal(e, item.id, item, item?.folio)
                    }
                    title="Procesar"
                  >
                    <i className="fas fa-cogs me-2"></i>
                  </button>
                )}

                <button
                  onClick={(e) => handleGeneratePdf(item.id, item?.folio)}
                  className="btn btn-migrates btn-migrates-cover btn-sm mb-1"
                  title="Imprimir reporte"
                >
                  <i className="fas fa-print" />
                </button>
                {/* {user.role === 7
                ? (item.StatusOfReport.name === 'Comunicar ejecución' ||
                    item.StatusOfReport.name === 'Comunicar cancelación') && (
                    <button
                      className="btn btn-migrates btn-sm"
                      onClick={(e) =>
                        handleOpenModal(e, item.id, item, item?.folio)
                      }
                    >
                      Procesar
                    </button>
                  )
                : item?.StatusOfReport?.name !== 'Comunicar ejecución' &&
                  item?.StatusOfReport?.name !== 'Comunicar cancelación' &&
                  item?.StatusOfReport?.name !== 'Solucionado' &&
                  item?.StatusOfReport?.name !== 'Cancelado' &&
                  item?.StatusOfReport?.name !== 'Cancelar' && (
                    <button
                      className="btn btn-migrates btn-sm"
                      onClick={(e) =>
                        handleOpenModal(e, item.id, item, item?.folio)
                      }
                    >
                      Procesar
                    </button>
                  )} */}
                {/* 
              {item.StatusOfReport.name !== 'Comunicar Ejecución' &&
                item.StatusOfReport.name !== 'Comunicar Cancelación' &&
                item.StatusOfReport.name !== 'Solucionado' && (
                  <button
                    className="btn btn-migrates btn-sm"
                    onClick={(e) => handleOpenModal(e, item.id, item)}
                  >
                    Procesar
                  </button>
                )} */}
                {user?.role !== objNameRoles.atencion_ciudadana && (
                  <button
                    onClick={() =>
                      handleReportsDuplicated(
                        item?.id,
                        item?.group_id,
                        item?.group_category_id,
                        item?.group_category_sub_id,
                        item?.zone_id,
                        item?.colony_id ? parseInt(item.colony_id) : null
                      )
                    }
                    className="btn btn-migrates btn-migrates-cover btn-sm mb-1"
                    title="Ver reportes duplicados"
                  >
                    <i className="fas fa-clone me-2 text-warning"></i>
                  </button>
                )}
              </div>
            </div>
          ),
        })
      })
      setDataToTable(list)
      setTotal(data.getAllReports.count)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, error, data, statusOfRole])

  useEffect(() => {
    if (user.role) {
      if (user.role === objNameRoles.gestor_global) {
        return setArraySelectStatus(fnStatusArrayCanSeeRole_globalManager())
      } else if (user.role === objNameRoles.gestor_interno) {
        return setArraySelectStatus(fnStatusArrayCanSeeRole_internalManager())
      }

      return setArraySelectStatus(fnArraySelectStatus())
    }
  }, [user.role])

  useEffect(() => {
    if (!loadingJurisdictionsAndSubs) {
      const list = dataJurisdictionsAndSubs?.getAllJurisdictionsAndSubs.map(
        (jurisdiction) => {
          const subs = jurisdiction.SubsOfJurisdiction.map((sub) => ({
            value: sub?.id,
            label: sub?.name,
          }))

          return {
            value: jurisdiction.id,
            label: jurisdiction?.name,
            subs,
          }
        }
      )
      if (isGestorInterno && user.jurisdiction_id) {
        return setVarsJurisdiction((old) => ({
          ...old,
          jurisdiccionSelected: list,
          subJurisdiccionSelected: null,
          subJurisdictions: list[0]?.subs.length > 0 ? list[0].subs : [],
        }))
      }

      setVarsJurisdiction((old) => ({ ...old, jurisdictions: list }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    loadingJurisdictionsAndSubs,
    dataJurisdictionsAndSubs,
    errorJurisdictionsAndSubs,
  ])

  useEffect(() => {
    if (modal) {
      document.getElementById(`spanModal${modal.modalId}`).click()
    }
  }, [modal])

  useEffect(() => {
    if (closeModal) {
      document.getElementById(`spanModal${modal.modalId}`).click()
      setTimeout(() => {
        setModal({
          id: false,
          modalId: false,
          size: 'extra',
          title: '',
          content: null,
        })
        setCloseModal(false)
      }, 400)
    }
  }, [closeModal])

  //Load filter options
  useEffect(() => {
    if (!loadingStatus && !loadingJuri && !loadingGroupsCategoriesSubs) {
      if (errorStatus || errorJuri || errorGroupsCategoriesSubs) {
        return toastSweetAlert({
          mode: 'error',
          message: errorStatus
            ? errorStatus.message
            : errorJuri
            ? errorJuri.message
            : errorGroupsCategoriesSubs.message,
        })
      }

      //Load status
      const status = []
      const modalOptionsStatus = []

      dataStatus?.getAllCatalogStatus.rows.forEach((item) => {
        status.push({
          value: item.id,
          label: item.name,
        })

        modalOptionsStatus.push(
          <option value={item.id} key={item.id}>
            {item.name}
          </option>
        )
      })

      //Load Jurisdictions
      let jurisdictions = []
      dataJuri?.getAllJurisdictionsAndSubs.map((item) => {
        jurisdictions.push({
          value: item.id,
          label: item.name,
        })
      })

      //Load Zones
      let zones = []
      const modalOptionsZones = []
      dataJuri?.getAllJurisdictionsAndSubs.map((item) => {
        const { SubsOfJurisdiction } = item
        SubsOfJurisdiction?.map((sub) => {
          zones.push({
            value: sub.id,
            label: sub.name,
          })
          modalOptionsZones.push(
            <option value={sub.id} key={sub.id}>
              {sub.name}
            </option>
          )
        })
      })

      //Load Subcategories
      let subcategories = []
      const modalOptionsSubcategories = []

      dataGroupsCategoriesSubs?.getAllGroupsCategoriesSub.rows.forEach(
        (item) => {
          subcategories.push({
            value: item.id,
            label: item.name,
          })

          modalOptionsSubcategories.push(
            <option value={item.id} key={item.id}>
              {item.name}
            </option>
          )
        }
      )

      setFilterOptions((prevOptions) => ({
        ...prevOptions,
        status,
        jurisdictions,
        zones,
        subcategories,
        modalOptionsStatus,
        modalOptionsSubcategories,
        modalOptionsZones,
      }))
    }
  }, [
    loadingStatus,
    dataStatus,
    errorStatus,
    dataJuri,
    loadingJuri,
    errorJuri,
    dataGroupsCategoriesSubs,
    loadingGroupsCategoriesSubs,
    errorGroupsCategoriesSubs,
  ])

  useEffect(() => {
    if (!loadingColonies && !errorColonies) {
      if (dataColonies) {
        const colonies = dataColonies.getAllColonies.map((item) => ({
          value: item.id,
          label: item.name,
          nocolonia: item.nocolonia,
        }))

        setFilterOptions((old) => ({
          ...old,
          colonies,
        }))
      }
    }
  }, [dataColonies, loadingColonies, errorColonies])

  useEffect(() => {
    const savedFilters = localStorage.getItem('filtersReports')
    const savedSearchQuery = localStorage.getItem('filtersReportsSearchQuery')

    if (savedFilters) {
      setPagePagination((old) => ({
        ...old,
        searchQuery: savedSearchQuery ? JSON.parse(savedSearchQuery) : null,
        filtersReports: JSON.parse(savedFilters),
      }))
    }
  }, [])

  useEffect(() => {
    localStorage.setItem(
      'filtersReports',
      JSON.stringify(pagePagination.filtersReports)
    )
  }, [pagePagination.filtersReports])

  useEffect(() => {
    localStorage.setItem(
      'filtersReportsSearchQuery',
      JSON.stringify(pagePagination.searchQuery)
    )
  }, [pagePagination.searchQuery])

  useEffect(() => {
    if (isRoleEnlace) {
      const existsPriorityOption = priorityOptions.some(
        (option) => option.value === 'especial'
      )
      if (!existsPriorityOption) {
        priorityOptions.push({
          value: 'especial',
          label: 'Especial',
        })
      }

      setPagePagination((old) => ({
        ...old,
        filtersReports: {
          ...old.filtersReports,
          priority: 'especial', // Set default priority filter for enlace role
        },
      }))
    }
  }, [isRoleEnlace])

  const handleClearFilters = () => {
    const defaultFilters = {
      status_id: null,
      jurisdiction_id: null,
      sub_jurisdiction_id: null,
      zone_id: null,
      group_category_sub_id: null,
      nameColumnDateType: 'start_date',
      dateFrom: null,
      dateTo: null,
      own_reports: null,
      priority: null, // Reset priority filter
    }
    setPagePagination((old) => ({
      ...old,
      searchQuery: '',
      filtersReports: defaultFilters,
    }))
    localStorage.removeItem('filtersReports')
    localStorage.removeItem('filtersReportsSearchQuery')
    const searchBar = document.getElementById('searchBar')
    searchBar.value = ''

    const dateInputFrom = document.getElementById('dateInputFrom')
    if (dateInputFrom) dateInputFrom._flatpickr.setDate('', true)
    const dateInputTo = document.getElementById('dateInputTo')
    if (dateInputTo) dateInputTo._flatpickr.setDate('', true)
  }

  const handleChangeFilterDateRange = ({ dateValue, type }) => {
    const nameProp = type === 'from' ? 'dateFrom' : 'dateTo'
    const value = dateValue ? dateValue : null
    return setPagePagination((old) => ({
      ...old,
      filtersReports: {
        ...old.filtersReports,
        [nameProp]: value,
      },
    }))
  }

  const handleChangeSelectTypesDates = (e) => {
    const value = e.target.value ? e.target.value : null
    setTypeDateSelected(value)
    return setPagePagination((old) => ({
      ...old,
      filtersReports: {
        ...old.filtersReports,
        nameColumnDateType: value ?? null,
      },
    }))
  }

  const handleOpenModal = (e, reportId, report, folio) => {
    e.preventDefault()
    setModal({
      id: reportId,
      modalId: `modal${reportId}`,
      size: 'large',
      title: `Procesar reporte`,
      content: (
        <ModalStatus
          reportId={parseInt(reportId)}
          reportFolio={folio}
          reportData={report}
          user={user}
          groupCategory={report?.ReportToGroupCategory?.name}
          currentStatus={report?.StatusOfReport?.name}
          currentStatusId={report.status_id}
          refetchMain={refetch}
          setCloseModal={setCloseModal}
        />
      ),
    })
  }

  const handleGeneratePdf = async (reportId, folio) => {
    try {
      setModal({
        id: 1,
        modalId: `modal${1}`,
        size: 'extra',
        title: `PDF reporte ${folio}`,
        content: (
          <ModalReportPdf
            reportId={reportId}
            title={`${folio}`}
            filename={`${folio}.pdf`}
            pageSize="A4"
            pageOrientation="portrait"
          />
        ),
      })
    } catch (error) {
      toastSweetAlert({
        mode: 'errorToast',
        message: 'Error al descargar el reporte',
      })
    }
  }

  const handleReportsDuplicated = async (
    reportId,
    group_id,
    group_category_id,
    group_category_sub_id,
    zone_id,
    colony_id
  ) => {
    setModal({
      id: 1,
      modalId: `modal${1}`,
      size: 'extra',
      title: `Reportes duplicados`,
      content: (
        <ModalReportsDuplicated
          reportId={parseInt(reportId)}
          refetchOrigin={refetch}
          group_id={group_id}
          group_category_id={group_category_id}
          group_category_sub_id={group_category_sub_id}
          zone_id={zone_id}
          colony_id={colony_id}
        />
      ),
    })
  }

  const handleEditReport = async (reportId, folio) => {
    setModal({
      id: 1,
      modalId: `modal${1}`,
      size: 'extra',
      title: `Editar reporte ${folio}`,
      content: (
        <ModalEditReports
          reportId={parseInt(reportId)}
          folio={folio}
          refetchOrigin={refetch}
          setCloseModal={setCloseModal}
        />
      ),
    })
  }

  const handleFilters = (e, field) => {
    const filterSelected = e.target.value

    let mappedField = field
    if (field === 'from') mappedField = 'dateFrom'
    else if (field === 'to') mappedField = 'dateTo'

    setPagePagination((prev) => ({
      ...prev,
      filtersReports: {
        ...prev.filtersReports,
        [mappedField]: [
          'status_id',
          'jurisdiction_id',
          'sub_jurisdiction_id',
          'zone_id',
          'group_category_sub_id',
        ].includes(mappedField)
          ? parseInt(filterSelected)
          : filterSelected,
      },
    }))
  }

  const handleFiltersSelect = (e, field) => {
    console.log('e', e, field)
    setPagePagination((old) => ({
      ...old,
      filtersReports: {
        ...old.filtersReports,
        [field]: e ? e.value : null,
      },
    }))
  }

  const handleFiltersSelectMulti = (e, field) => {
    let arraySend = []
    if (e.length > 0) {
      arraySend = e.map((item) => item.value)
    }

    setPagePagination({
      ...pagePagination,
      filtersReports: {
        ...pagePagination.filtersReports,
        [field]: arraySend,
      },
    })
  }

  const sanitizeData = (obj) => {
    const problematicCharsRegex = /[\u0000-\u001F\u007F\uFFFD]/g // incluye caracteres de control y �

    const recurse = (data) => {
      if (typeof data === 'string') {
        return data.replace(problematicCharsRegex, ' ')
      } else if (Array.isArray(data)) {
        return data.map(recurse)
      } else if (typeof data === 'object' && data !== null) {
        const cleaned = {}
        for (const key in data) {
          cleaned[key] = recurse(data[key])
        }
        return cleaned
      } else {
        return data
      }
    }

    return recurse(obj)
  }

  const handleExportReports = async () => {
    console.log('EXPORTAR REPORTES')
    let statusesSelect = filterOptions?.status.filter((option) =>
      pagePagination.filtersReports.status_id?.includes(option.value)
    )
    let zonesSelect = filterOptions?.zones.filter((option) =>
      pagePagination.filtersReports.zone_id?.includes(option.value)
    )
    let subcategoriesSelect = filterOptions?.subcategories.filter((option) =>
      pagePagination.filtersReports.group_category_sub_id?.includes(
        option.value
      )
    )
    const response = await toastSweetAlert({
      mode: 'modalConfirmContent',
      title: 'Fechas para reportes',
      confirmButtonText: 'Aceptar',
      denyButtonClass:
        'btn btn-migrates-white export-reports-buttons',
      popupClass: 'tall-modal',
      content: (
        <>
          <div className="message-container w-100 d-flex justify-content-center">
            <div className="input-container" style={{ width: '80%' }}>
              <label className="form-label">
                Por favor, ingrese las fechas que desea exportar en reportes
              </label>
            </div>
          </div>

          <div
            className="message-container d-flex"
            style={{ justifyContent: 'space-around' }}
          >
            <div className="input-container" style={{ width: '40%' }}>
              <label htmlFor="date_start">Fecha de inicio</label>
              <input
                className="input-field form-control"
                type="date"
                id="date_start"
                defaultValue={pagePagination.filtersReports.dateFrom || ''}
              />
            </div>
            <div className="input-container" style={{ width: '40%' }}>
              <label htmlFor="date_end">Fecha de fin</label>
              <input
                className="input-field form-control"
                type="date"
                id="date_end"
                defaultValue={pagePagination.filtersReports.dateTo || ''}
              />
            </div>
          </div>
          <div className="message-container p-1 w-100 d-flex justify-content-center">
            <div className="input-container" style={{ width: '80%' }}>
              <label className="form-label">Estatuses seleccionados</label>
              <Select
                id="statusModalExport"
                isMulti
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999, // Asegúrate que sea mayor al del modal
                  }),
                  menu: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                }}
                options={filterOptions?.status}
                defaultValue={filterOptions?.status.filter((option) =>
                  pagePagination.filtersReports.status_id?.includes(
                    option.value
                  )
                )}
                onChange={(e) => (statusesSelect = e)}
              />

              {/* <select
                id="statusModalExport"
                className="input-field form-control form-select"
                multiple
              >
                {filterOptions?.modalOptionsStatus.map((option) => {
                  const isSelected =
                    pagePagination.filtersReports.status_id?.includes(
                      option.props.value
                    )
                  return React.cloneElement(option, {
                    selected: isSelected,
                  })
                })}
              </select> */}
            </div>
          </div>

          <div className="message-container p-1 w-100 d-flex justify-content-center">
            <div className="input-container" style={{ width: '80%' }}>
              <label className="form-label">Zonas seleccionadas</label>
              <Select
                id="zonesModalExport"
                isMulti
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999, // Asegúrate que sea mayor al del modal
                  }),
                  menu: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                }}
                options={filterOptions?.zones}
                defaultValue={filterOptions?.zones.filter((option) =>
                  pagePagination.filtersReports.zone_id?.includes(option.value)
                )}
                onChange={(e) => (zonesSelect = e)}
              />

              {/* <select
                id="zonesModalExport"
                className="input-field form-control form-select"
                multiple
              >
                {filterOptions?.modalOptionsZones.map((option) => {
                  const isSelected =
                    pagePagination.filtersReports.zone_id?.includes(
                      option.props.value
                    )
                  return React.cloneElement(option, {
                    selected: isSelected,
                  })
                })}
              </select> */}
            </div>
          </div>

          <div className="message-container p-1 w-100 d-flex justify-content-center">
            <div className="input-container" style={{ width: '80%' }}>
              <label className="form-label">Subcategorías seleccionadas</label>
              <Select
                id="subcategoriesModalExport"
                isMulti
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999, // Asegúrate que sea mayor al del modal
                  }),
                  menu: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                }}
                options={filterOptions?.subcategories}
                defaultValue={filterOptions?.subcategories.filter((option) =>
                  pagePagination.filtersReports.group_category_sub_id?.includes(
                    option.value
                  )
                )}
                onChange={(e) => (subcategoriesSelect = e)}
              />

              {/* <select
                id="subcategoriesModalExport"
                className="input-field form-control form-select"
                multiple
              >
                {filterOptions?.modalOptionsSubcategories.map((option) => {
                  const isSelected =
                    pagePagination.filtersReports.group_category_sub_id?.includes(
                      option.props.value
                    )
                  return React.cloneElement(option, {
                    selected: isSelected,
                  })
                })}
              </select> */}
            </div>
          </div>
        </>
      ),
      validator: () => validatorDates(),
    })

    if (!response.isConfirmed) return

    showLoading()
    try {
      const date_start = document.getElementById('date_start').value
      const date_end = document.getElementById('date_end').value

      const statusIds = statusesSelect?.map((status) => status.value)
      const zonesIds = zonesSelect?.map((zone) => zone.value)
      const subcategoriesIds = subcategoriesSelect?.map((sub) => sub.value)

      // const statusSelect = Array.from(
      //   document.getElementById('statusModalExport').selectedOptions
      // ).map((option) => parseInt(option.value))

      // const subcategoriesSelect = Array.from(
      //   document.getElementById('subcategoriesModalExport').selectedOptions
      // ).map((option) => parseInt(option.value))

      // const zonesSelect = Array.from(
      //   document.getElementById('zonesModalExport').selectedOptions
      // ).map((option) => parseInt(option.value))

      const res = await ExportReports({
        variables: {
          dateFrom: date_start,
          dateTo: date_end,
          statusIds,
          subcategoriesIds,
          zonesIds,
        },
      })
      if (res.data.exportReports.length === 0) {
        hideLoading()
        return toastSweetAlert({
          mode: 'error',
          message: 'No hay reportes para exportar',
        })
      }

      let list = []
      res.data.exportReports.map((item) => {
        const {
          latitude = null,
          longitude = null,
          reference = 'N/A',
          state = 'N/A',
          street = 'N/A',
          url_google_map = 'N/A',
          zipcode = 'N/A',
          address_full = 'N/A',
          city = 'N/A',
        } = item?.AddressOfReport || {}

        let ciudadano = 'N/A'
        let phoneCitizen = 'N/A'
        if (item.channel_capture === 'tlajochat') {
          ciudadano = item?.UserTlajoChatOfReport?.name || 'N/A'
          phoneCitizen = item?.UserTlajoChatOfReport?.phone || 'N/A'
        }

        if (item.channel_capture === 'web') {
          // if (item?.ReportToUsers?.name === 'Anónimo') {
          //   ciudadano = item?.ReportToUsers?.name || 'N/A'
          //   phoneCitizen = item?.ReportToUsers?.phone || 'N/A'
          // } else {
          ciudadano = item?.ReportCitizenOfUsers?.name || 'N/A'
          phoneCitizen = item?.ReportCitizenOfUsers?.phone || 'N/A'
          // }
        }

        if (item.channel_capture === 'web_gestor') {
          ciudadano = item?.ReportToUsers?.name || 'N/A'
        }

        if (item.channel_capture === 'app') {
          ciudadano = item?.ReportToUsers?.name
          phoneCitizen = item?.ReportToUsers?.phone || 'N/A'
        }

        if (item.channel_capture === 'web_anonymous') {
          ciudadano = item?.ReportToUsers?.name || 'N/A'
          phoneCitizen = item?.ReportToUsers?.phone || 'N/A'
        }

        // Convertir string a objeto JSON
        let dataFormJson = JSON.parse(item.data_form_json)

        if ('evidences' in dataFormJson)
          // Si existe, eliminar la propiedad
          delete dataFormJson.evidences

        dataFormJson = sanitizeData(dataFormJson)
        list.push({
          Tipo: item?.ReportToGroupCategory?.name,
          Canal:
            item?.channel_capture === 'app'
              ? 'App'
              : webChannels.includes(item?.channel_capture)
              ? 'Web'
              : 'TlajoChat',

          // item?.channel_capture,
          Folio: item?.folio,
          'Fecha inicio': !item.start_date
            ? 'N/A'
            : moment(item.start_date).format(
                'dddd D [de] MMMM [de] YYYY HH:mm [hrs]'
              ),
          Estatus: item?.StatusOfReport?.name,
          Zona: item?.JurisdictionsSubOfReport?.name,
          Ciudadano: ciudadano,
          'Teléfono Ciudadano': phoneCitizen,
          // Ciudadano: item?.ReportToUsers?.name || 'N/A',
          Subcategoría: item?.ReportToGroupCategorySub?.name,
          Estado: state,
          Colonia: city,
          // Ciudad: city,
          //Calle: street,
          Código_Postal: zipcode,
          Referencia: reference,
          'URL Google Maps': url_google_map,
          Latitud: latitude,
          Longitud: longitude,
          'Dirección Completa':
            address_full !== null && address_full !== ''
              ? address_full
              : street + ' - ' + city,
          ...dataFormJson,
        })
      })
      setDataToTableExport(list)
      hideLoading()
      return (
        toastSweetAlert({
          mode: 'ok',
          message: 'Reportes exportados exitosamente',
        }),
        document.getElementById('exportfileCSV').click()
      )
    } catch (error) {
      hideLoading()
      toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }

  const validatorDates = () => {
    const date_start = document.getElementById('date_start').value
    const date_end = document.getElementById('date_end').value

    if (!date_start || !date_end) {
      hideLoading()
      return Swal.showValidationMessage(
        `Por favor, defina el rango de fechas para la exportación`
      )
    }

    if (new Date(date_start) > new Date(date_end)) {
      return Swal.showValidationMessage(
        'La fecha de inicio no puede ser mayor que la fecha de fin'
      )
    }

    const startDate = new Date(date_start)
    const endDate = new Date(date_end)
    const diffTime = Math.abs(endDate - startDate)
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

    if (diffDays > 59) {
      return Swal.showValidationMessage(
        'El rango de fechas no puede ser mayor a 60 días'
      )
    }
    return true
  }

  const contextMenuFolio = (item, reportSolved) => {
    return (
      <>
        <button
          className="btn btn-sm btn-transparent dropdown-toggle mt-1 mb-1"
          id="dropdownMenuButton"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"

          // type="button"
          // className="btn btn-sm btn-default dropdown-toggle"
          // data-bs-toggle="dropdown"
          // aria-expanded="false"
        >
          {item?.folio}
        </button>
        <div className="dropdown-menu" aria-label="dropdownMenuButton">
          <Link
            className="dropdown-item"
            to={`/reports/details/${item?.id}/show`}
          >
            <i className="fas fa-eye text-primary"></i> Ver detalles
          </Link>

          <button
            onClick={(e) => handleGeneratePdf(item.id, item?.folio)}
            className="dropdown-item"
          >
            <i className="fas fa-print text-primary" /> Imprimir
          </button>

          {foundStatusCurrentInStatusRole(item.status_id) && (
            <button
              className="dropdown-item"
              onClick={(e) => handleOpenModal(e, item.id, item, item?.folio)}
            >
              <i className="fas fa-cogs me-2 text-success"></i> Procesar
            </button>
          )}

          {buttonsPermissions.edit && !reportSolved && (
            // item.priority !== 'especial' &&
            <button
              className="dropdown-item"
              onClick={(e) => handleEditReport(item.id, item?.folio)}
            >
              <i className="fas fa-edit mr-1 text-warning" /> Editar
            </button>
          )}

          {user?.role !== objNameRoles.atencion_ciudadana && (
            <button
              onClick={() =>
                handleReportsDuplicated(
                  item?.id,
                  item?.group_id,
                  item?.group_category_id,
                  item?.group_category_sub_id,
                  item?.zone_id,
                  item?.colony_id ? parseInt(item.colony_id) : null
                )
              }
              className="dropdown-item"
            >
              <i className="fas fa-clone me-2 text-warning"></i> Ver duplicados
            </button>
          )}
        </div>
      </>
    )
  }

  const handleSwitch = (value) => {
    setPagePagination((old) => ({
      ...old,
      filtersReports: {
        ...old.filtersReports,
        own_reports: value?.target?.checked,
      },
    }))
  }

  const handleShowInfoUserApp = async (userAppId) => {
    setModal({
      id: 1,
      modalId: `modal${1}`,
      size: 'extra',
      title: `Datos de usuario app`,
      content: (
        <ModalReportUserAppInfo
          userAppId={parseInt(userAppId)}
          refetchOrigin={refetch}
          setCloseModal={setCloseModal}
        />
      ),
    })
  }

  const handleExportReportCounters = async () => {
    try {
      let subcategoriesSelect = filterOptions?.subcategories.filter((option) =>
        pagePagination.filtersReports.group_category_sub_id?.includes(
          option.value
        )
      )

      const response = await toastSweetAlert({
        mode: 'modalConfirmContent',
        title: 'Exportar resumen de reportes',
        confirmButtonText: 'Aceptar',
        denyButtonClass:
          'btn btn-migrates-white export-reports-buttons',
        popupClass: 'tall-modal',
        content: (
          <>
            <div className="message-container w-100 d-flex justify-content-center">
              <div className="input-container" style={{ width: '80%' }}>
                <label className="form-label">
                  Por favor, ingrese las fechas que desea exportar en resumen de
                  reportes
                </label>
              </div>
            </div>

            <div
              className="message-container d-flex"
              style={{ justifyContent: 'space-around' }}
            >
              <div className="input-container" style={{ width: '40%' }}>
                <label htmlFor="date_start">Fecha de inicio</label>
                <input
                  className="input-field form-control"
                  type="date"
                  id="date_start"
                  defaultValue={pagePagination.filtersReports.dateFrom || ''}
                />
              </div>
              <div className="input-container" style={{ width: '40%' }}>
                <label htmlFor="date_end">Fecha de fin</label>
                <input
                  className="input-field form-control"
                  type="date"
                  id="date_end"
                  defaultValue={pagePagination.filtersReports.dateTo || ''}
                />
              </div>
            </div>

            <div className="message-container p-1 w-100 d-flex justify-content-center">
              <div className="input-container" style={{ width: '80%' }}>
                <label className="form-label">
                  Subcategorías seleccionadas
                </label>
                <Select
                  id="subcategoriesModalExport"
                  isMulti
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999, // Asegúrate que sea mayor al del modal
                    }),
                    menu: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                  }}
                  options={filterOptions?.subcategories}
                  defaultValue={filterOptions?.subcategories.filter((option) =>
                    pagePagination.filtersReports.group_category_sub_id?.includes(
                      option.value
                    )
                  )}
                  onChange={(e) => (subcategoriesSelect = e)}
                  placeholder="Selecciona subcategorías"
                />
              </div>
            </div>
          </>
        ),
        validator: () => validatorDates(),
      })

      if (!response.isConfirmed) return

      const date_start = document.getElementById('date_start').value
      const date_end = document.getElementById('date_end').value
      const subcategoriesIds = subcategoriesSelect?.map((sub) => sub.value)

      showLoading()
      const renameColumns = {
        group_name: 'Categoría',
        sub_group_name: 'Subcategoría',
        completed: 'Total solucionados',
        canceled: 'Total cancelados',
        pending: 'Total pendientes',
        app: 'Total app',
        tlajochat: 'Total tlajochat',
        web: 'Total web',
        total: 'Gran Total',
      }

      const reOderColumns = {
        group_name: 0,
        sub_group_name: 1,
        completed: 2,
        canceled: 3,
        pending: 4,
        app: 5,
        tlajochat: 6,
        web: 7,
        total: 8,
      }

      const { data: dataExportation } = await exportCounterReports({
        variables: {
          filters: {
            start_date: date_start,
            end_date: date_end,
            array_group_category_sub_id: subcategoriesIds,
          },
        },
        fetchPolicy: 'no-cache',
      })

      const dataExport = dataExportation.exportActivityReportsCounters.map(
        (item) => {
          const newItem = {}
          // Reorder the columns based on the orderColumn mapping
          Object.keys(item)
            .sort((a, b) => {
              const orderA = reOderColumns[a] || 0
              const orderB = reOderColumns[b] || 0
              return orderA - orderB
            })
            .forEach((key) => {
              if (renameColumns[key]) {
                newItem[renameColumns[key]] = item[key]
              } else {
                newItem[key] = item[key]
              }
            })
          return newItem
        }
      )

      setDataToTableExport(dataExport)
      setTimeout(() => {
        document.getElementById('exportfileCSV').click()
      }, 400)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
    }
  }

  return (
    <>
      <CSVLink
        id="exportfileCSV"
        filename={'Reportes.csv'}
        data={dataToTableExport}
        className="hide"
      ></CSVLink>
      <ContentHeader title="Reportes" breadcrumb="" windowTitle="Reportes" />

      <div className="reports reports-layout">
        <LayoutTable
          title="Lista de reportes"
          hideId
          hideActions
          hideAddNew
          data={dataToTable}
          requery={GET_ALL_REPORTS}
          exportImportButton={false}
          totalCount={total}
          pagePagination={pagePagination}
          setPagePagination={setPagePagination}
          loadingData={loading}
          FilterBarPlaceholder="Buscar por folio, ciudadano o teléfono"
          filterBarValue={pagePagination.searchQuery}
          // showAddNewButton={
          //   user.role === objNameRoles.gestor_global ||
          //   user.role === objNameRoles.gestor_interno ||
          //   user.role === objNameRoles.gestor_global_independiente ||
          //   user.role === objNameRoles.admin ||
          //   user.role === objNameRoles.master
          // }
          // handleAddNewButton={handleExportReports}
          // handleAddNewButtonTxt="Exportar"
          showSwitchFilter
          handleShowSwitchFilter={handleSwitch}
          showSwitchFilterChecked={
            pagePagination.filtersReports.own_reports ?? false
          }
          showSwitchFilterTxt="Mis reportes"
          headerComponents={
            <>
              <button
                className="btn btn-purple btn-sm"
                title="Limpiar filtros"
                onClick={handleClearFilters}
              >
                <i className="fas fa-times" /> Limpiar filtros
              </button>
            </>
          }
          extraButtonsExport={
            <>
              {isAllowed && (
                <button
                  className="btn btn-purple btn-sm ml-2"
                  title="Exportar reportes"
                  onClick={handleExportReportCounters}
                >
                  Resumen de reportes
                </button>
              )}
            </>
          }
          filter
          filterOnChange={(e) => handleFiltersSelectMulti(e, 'status_id')}
          filterOptions={filterOptions?.status}
          // filterLabelText="Estatus"
          filterDefaultOptionText="Elige estatus"
          filterTypeSelect="selectMultiple"
          defaultValueSelect={pagePagination.filtersReports.status_id
            ?.map((statusId) => {
              const match = filterOptions?.status?.find(
                (status) => status.value === statusId
              )
              return match ? { label: match.label, value: match.value } : null
            })
            .filter(Boolean)}
          // filterSecond
          // filterOnChangeSecond={(e) => handleFilters(e, 'jurisdiction_id')}
          // filterOptionsSecond={filterOptions?.jurisdictions?.map((item) => (
          //   <option
          //     value={item.value}
          //     key={item.value}
          //     selected={
          //       pagePagination.filtersReports.jurisdiction_id === item.value
          //     }
          //   >
          //     {item.label}
          //   </option>
          // ))}
          // // filterLabelTextSecond="Jurisdicción"
          // filterDefaultOptionTextSecond="Jurisdicción"
          // filterThird
          // filterOnChangeThird={(e) => handleFilters(e, 'nameColumnDateType')}
          // filterOptionsThird={filterRangeTypesDateOptions.map((item) => (
          //   <option
          //     value={item.value}
          //     key={item.value}
          //     selected={
          //       pagePagination.filtersReports.nameColumnDateType === item.value
          //     }
          //   >
          //     {item.label}
          //   </option>
          // ))}
          // defaultValueSelectThird={'start_date'}
          // filterLabelTextThird="Fecha de inicio"

          filterFourth
          filterOnChangeFourth={(e) => handleFiltersSelectMulti(e, 'zone_id')}
          filterOptionsFourth={filterOptions?.zones}
          // filterLabelTextSecond="Jurisdicción"
          filterDefaultOptionTextFourth="Elige Zona(s)"
          filterTypeSelectFourth="selectMultiple"
          defaultValueSelectFourth={pagePagination.filtersReports.zone_id
            ?.map((zoneId) => {
              const match = filterOptions?.zones?.find(
                (zone) => zone.value === zoneId
              )
              return match ? { label: match.label, value: match.value } : null
            })
            .filter(Boolean)}
          filterFifth
          filterOnChangeFifth={(e) =>
            handleFiltersSelectMulti(e, 'group_category_sub_id')
          }
          filterOptionsFifth={filterOptions?.subcategories}
          // filterLabelTextSecond="Jurisdicción"
          filterDefaultOptionTextFifth="Elige Subcategoría(s)"
          filterTypeSelectFifth="selectMultiple"
          defaultValueSelectFifth={pagePagination.filtersReports.group_category_sub_id
            ?.map((subId) => {
              const match = filterOptions?.subcategories?.find(
                (sub) => sub.value === subId
              )
              return match ? { label: match.label, value: match.value } : null
            })
            .filter(Boolean)}
          //TODO: SE COMENTA, SE DEBE DESCOMENTAR EN EL MOMENTO INDICADO
          //
          filterSix
          filterOnChangeSix={(e) => handleFiltersSelectMulti(e, 'colony_id')}
          filterOptionsSix={filterOptions?.colonies}
          filterDefaultOptionTextSix="Elige colonia(s)"
          filterTypeSelectSix="selectMultiple"
          defaultValueSelectSix={pagePagination.filtersReports.colony_id
            ?.map((colony_id) => {
              const match = filterOptions?.colonies?.find(
                (colony) => colony.value === colony_id
              )
              return match ? { label: match.label, value: match.value } : null
            })
            .filter(Boolean)}
          filterChoosen={[
            {
              id: 'priority',
              name: 'Prioridad',
              value: pagePagination.filtersReports.priority,
              onChange: (e) => handleFiltersSelect(e, 'priority'),
              options: filterOptions?.priorityOptions,
              isSearchable: true,
              isClearable: !isRoleEnlace,
              isDisabled: isRoleEnlace,
              placeholder: 'Elige prioridad',
            },
          ]}
          cols_search="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4"
          cols_search_div="col-12"
          cols_filters="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-3 mt-3"
          cols_filters_div="col-12"
          // cols_filter_range_show='col-12 d-flex flex-wrap mb-3 justify-content-end'

          isFilterRangeShow
          filterRangeProps={{
            from: {
              value: pagePagination.filtersReports.dateFrom,
              id: 'dateInputFrom',
              // label: 'Fecha inicio',
            },
            to: {
              value: pagePagination.filtersReports.dateTo,
              id: 'dateInputTo',
              // label: 'Fecha fin',
            },
            changeFilterDateRange: handleFilters,
          }}
          exportOnClick={handleExportReports}
          titleExportOnClick="Exportar"
        />
      </div>

      <span
        ref={refModalFilters}
        className="btn btn-migrates btn-sm invisible"
        data-toggle="modal"
        data-target={`#${idModalFilters}`}
      />

      {/* <ModalContentAux
        idModal={idModalFilters}
        size="large"
        showFooter={false}
        classModalDialog="modal-dialog-scrollable"
        title={
          <>
            <i className="fas fa-filter" /> Filtros
          </>
        }
        content={
          <ReportsFilters
            user={user}
            setPagePagination={setPagePagination}
            pagePagination={pagePagination}
            setIsFiltered={setIsFiltered}
            isFiltered={isFiltered}
          />
        }
      /> */}

      <span
        id={`spanModal${modal.modalId}`}
        className="invisible"
        data-toggle="modal"
        data-target={`#${modal.modalId}`}
        data-backdrop="static"
        data-keyboard="false"
        data-dismiss="modal"
        ref={refModalStatus}
      />

      <ModalContent
        idModal={modal.modalId}
        title={modal.title}
        size={modal.size}
        onClose={() => {
          setModal({
            title: '',
            content: null,
            modalId: null,
            size: 'extra',
          })
        }}
        content={modal.content}
      />
    </>
  )
}

const LabelRangeDate = ({ text, icon = true }) => {
  return (
    <span style={{ fontSize: 14 }}>
      <b>
        {icon && (
          <i className="far fa-calendar-alt mr-1" style={{ fontSize: 11 }} />
        )}
        {text}
      </b>
    </span>
  )
}

export default Reports
